import {
	getDateTimePickerFieldValue,
	getDatePickerFieldValue,
} from './get-field-value/get-date-fields-value/index.tsx';
import { getLabelsFieldValue } from './get-field-value/get-labels-field-value/index.tsx';
import { getMultipleSelectFieldValue } from './get-field-value/get-multiple-select-field-value/index.tsx';
import { getMultipleVersionPickerFieldValue } from './get-field-value/get-multiple-version-picker-value/index.tsx';
import { getNumberFieldValue } from './get-field-value/get-number-field-value/index.tsx';
import { getRichTextFieldValue } from './get-field-value/get-rich-text-field-value/index.tsx';
import { getSingleSelectFieldValue } from './get-field-value/get-single-select-field-value/index.tsx';
import { getSingleVersionPickerValue } from './get-field-value/get-single-version-picker-value/index.tsx';
import {
	getStringFieldValue,
	getForgeObjectFieldValue,
} from './get-field-value/get-string-field-value/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fieldMap: Record<string, any> = {
	JiraDateTimePickerField: getDateTimePickerFieldValue,
	JiraSingleVersionPickerField: getSingleVersionPickerValue,
	JiraRichTextField: getRichTextFieldValue,
	JiraConnectRichTextField: getRichTextFieldValue,
	JiraUrlField: getStringFieldValue,
	JiraSingleLineTextField: getStringFieldValue,
	JiraConnectTextField: getStringFieldValue,
	JiraNumberField: getNumberFieldValue,
	JiraConnectNumberField: getNumberFieldValue,
	JiraSingleSelectField: getSingleSelectFieldValue,
	JiraRadioSelectField: getSingleSelectFieldValue,
	JiraConnectSingleSelectField: getSingleSelectFieldValue,
	JiraCheckboxesField: getMultipleSelectFieldValue,
	JiraMultipleVersionPickerField: getMultipleVersionPickerFieldValue,
	JiraMultipleSelectField: getMultipleSelectFieldValue,
	JiraConnectMultipleSelectField: getMultipleSelectFieldValue,
	JiraLabelsField: getLabelsFieldValue,
	JiraDatePickerField: getDatePickerFieldValue,
	JiraTextAreaField: getStringFieldValue,
	JiraForgeNumberField: getNumberFieldValue,
	JiraForgeDatetimeField: getDateTimePickerFieldValue,
	JiraForgeDateField: getDatePickerFieldValue,
	JiraForgeStringsField: getLabelsFieldValue,
	JiraForgeStringField: getStringFieldValue,
	JiraForgeObjectField: getForgeObjectFieldValue,
};

export const prefillCustomFieldMap = ({
	gqlType,
	defaultValue,
	allowedValues,
}: {
	gqlType: string;
	defaultValue: unknown;
	allowedValues?: unknown;
}) => {
	if (typeof fieldMap[gqlType] !== 'function') return null;
	if (allowedValues) {
		return fieldMap[gqlType]({ defaultValue, allowedValues });
	}
	return fieldMap[gqlType](defaultValue);
};

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { getCascadingSelectFieldValue } from './get-field-value/get-cascading-select-field-value/index.tsx';

export const getWorkLogFieldValues = (key: unknown, input: unknown) => {
	if (key === 'worklog_timeLogged') {
		return { timeSpent: getStringFieldValue(input) };
	}
	if (key === 'worklog_startDate') {
		return {
			dateValue: getDateTimePickerFieldValue(input),
		};
	}
	if (key === 'worklog_comment') {
		return {
			description: getRichTextFieldValue(input),
		};
	}
	if (key === 'timetracking_remainingestimate') {
		return {
			timeRemaining: getStringFieldValue(input),
		};
	}
};

export const workLogSubFieldTypes: string[] = [
	'worklog_timeLogged',
	'worklog_startDate',
	'worklog_comment',
	'timetracking_remainingestimate',
];
